import React from 'react'
import centerPicture1920 from '../../../../images/relocation/centerPicture1920.svg'
import centerPicture1440 from '../../../../images/relocation/centerPicture1440.svg'
import centerPicture1024 from '../../../../images/relocation/centerPicture1024.svg'
// import centerPicture768 from '../../../../images/relocation/centerPicture768.svg'
import centerPicture768Png from '../../../../images/relocation/centerPicture768.png'

import styles from './styles.module.scss'

const InfoVolginsky = ({ routeBlockVacancies }) => {
  return (
    <div className={styles.wrapper}>
      <div className={styles.wrapper_totalBlock}>
        <div className={styles.wrapper_left}>
          <p className={styles.wrapper_left_p1}>Посёлок Вольгинский</p>
        </div>
        <div className={styles.wrapper_right}>
          <div className={styles.wrapper_right_up}>
            <p className={styles.wrapper_right_p2}>Работа в двух<br/>шагах от дома</p>
            <p>
              Большинство сотрудников компании живут и работают в поселке Вольгинском во Владимирской области. В нем мы
              создали идеальные условия для личностного и профессионального развития: новейшее научное оборудование,
              спортивные залы, живописные виды и сообщество экспертов международного класса.
            </p>
          </div>
          <img className={styles.center_img768} src={centerPicture768Png} alt='centerPicture' draggable='false' />
          <div className={styles.wrapper_right_down}>
            <div className={styles.wrapper_right_title}>
              Посмотрите, <br /> где мы работаем
            </div>
          </div>
        </div>
      </div>

      <div className={styles.rightSide_iframe}>
        <iframe
          src="https://vk.com/video_ext.php?oid=-221108214&id=456239040&hd=2"
          title='VK video player'
          allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
          frameborder="0"
          allowfullscreen
        />
      </div>
      <div className={styles.center_picture}>
        <img className={styles.center_img1920} src={centerPicture1920} alt='centerPicture' draggable='false' />
        <img className={styles.center_img1440} src={centerPicture1440} alt='centerPicture' draggable='false' />
        <img className={styles.center_img1024} src={centerPicture1024} alt='centerPicture' draggable='false' />
      </div>
    </div>
  )
}

export default InfoVolginsky
